(function () {
  const MOBILE_QUERY = '(max-width: 992px)';

  function getSectionRoot(el) {
    return el.closest('[data-industry-leaders]');
  }

  function getSlides(section) {
    return Array.from(section.querySelectorAll('[data-industry-slide]'));
  }

  function getTrack(section) {
    return section.querySelector('.collaboration-industry-leaders__track');
  }

  function getSlideScrollLeft(track, slide) {
    const paddingLeft = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    return Math.max(0, slide.offsetLeft - paddingLeft);
  }

  function scrollToSlide(section, slide, behavior) {
    const track = getTrack(section);
    if (!track || !slide) return;

    track.scrollTo({ left: getSlideScrollLeft(track, slide), behavior: behavior || 'smooth' });
  }

  function getClosestSlideIndex(track, slides) {
    if (!track || !slides.length) return 0;

    const scrollLeft = track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(getSlideScrollLeft(track, slide) - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function setActiveSlide(section, slideId, options) {
    if (!section || !slideId) return;

    const opts = options || {};
    const slides = getSlides(section);

    slides.forEach((slide) => {
      const isActive = slide.dataset.industrySlide === slideId;
      slide.classList.toggle('is-active', isActive);
    });

    const activeSlide = slides.find((slide) => slide.dataset.industrySlide === slideId);
    if (activeSlide && window.matchMedia(MOBILE_QUERY).matches && !opts.skipScroll) {
      scrollToSlide(section, activeSlide, opts.behavior);
    }

    updateNavState(section);
  }

  function updateNavState(section) {
    const slides = getSlides(section);
    const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const prevBtn = section.querySelector('[data-industry-nav="prev"]');
    const nextBtn = section.querySelector('[data-industry-nav="next"]');

    if (prevBtn) prevBtn.disabled = activeIndex <= 0;
    if (nextBtn) nextBtn.disabled = activeIndex >= slides.length - 1;
  }

  function bindTrackScroll(section) {
    const track = getTrack(section);
    if (!track || track.dataset.industryScrollBound === 'true') return;

    track.dataset.industryScrollBound = 'true';

    let scrollTimer;
    track.addEventListener('scroll', () => {
      if (!window.matchMedia(MOBILE_QUERY).matches) return;

      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const slides = getSlides(section);
        const closestIndex = getClosestSlideIndex(track, slides);
        const closestSlide = slides[closestIndex];

        if (closestSlide && !closestSlide.classList.contains('is-active')) {
          setActiveSlide(section, closestSlide.dataset.industrySlide, { skipScroll: true });
        } else {
          updateNavState(section);
        }
      }, 80);
    });
  }

  function initSection(section) {
    const slides = getSlides(section);
    if (!slides.length) return;

    bindTrackScroll(section);

    const activeSlide = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
    setActiveSlide(section, activeSlide.dataset.industrySlide, { behavior: 'auto' });

    if (window.matchMedia(MOBILE_QUERY).matches) {
      requestAnimationFrame(() => {
        scrollToSlide(section, activeSlide, 'auto');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-industry-leaders]').forEach(initSection);
  }

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-industry-nav]');
    if (!nav) return;

    const section = getSectionRoot(nav);
    if (!section) return;

    const slides = getSlides(section);
    const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const direction = nav.dataset.industryNav;
    const nextIndex = direction === 'next' ? activeIndex + 1 : activeIndex - 1;

    if (nextIndex < 0 || nextIndex >= slides.length) return;

    setActiveSlide(section, slides[nextIndex].dataset.industrySlide);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-industry-leaders]');
    if (section) initSection(section);
  });
})();
